import { NamespaceConsumer } from '@ux/namespace-component';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tray close component.
 *
 *
 * @class TrayClose
 * @public
 */
export default class TrayClose extends NamespaceConsumer {
  /**
   * Render the component.
   *
   * @returns {ReactElement} close button.
   * @api public
   */
  render() {
    const props = this.props;
    return (
      <button className={ this.namespace('close') } onClick={ props.onClick }></button>
    );
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
TrayClose.propTypes = {
  onClick: PropTypes.func.isRequired
};
